module.exports = __webpack_public_path__ + "img/pg2-title.cf166b0f.png";